import React, { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import PublicNav from "@/components/PublicNav";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const session_id = sp.get("session_id");
  const [status, setStatus] = useState({ status: "pending" });
  const [tries, setTries] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const poll = async () => {
      if (!session_id || cancelled) return;
      try {
        const { data } = await api.get(`/fee/checkout/status/${session_id}`);
        if (cancelled) return;
        setStatus(data);
        if (data.status !== "paid" && tries < 12) {
          setTimeout(() => setTries((t) => t + 1), 1500);
        }
      } catch (e) { if (!cancelled) setStatus({ status: "error" }); }
    };
    poll();
    return () => { cancelled = true; };
  }, [session_id, tries]);

  return (
    <div className="min-h-screen bg-[#F8F9FA]"><PublicNav />
      <div className="max-w-lg mx-auto px-6 py-16">
        <Card className="p-8 text-center">
          {status.status === "paid" ? (
            <><CheckCircle2 className="w-16 h-16 text-emerald-600 mx-auto mb-4" />
              <h1 className="text-2xl font-bold text-slate-900">Payment Successful</h1>
              <p className="text-slate-600 mt-2">₹{Number(status.amount || 0).toLocaleString()} has been credited to your child's fee ledger.</p>
              <div className="flex gap-2 justify-center mt-6">
                <Button onClick={() => nav("/parent")} data-testid="ps-back">Back to Portal</Button>
              </div>
            </>
          ) : (
            <><Loader2 className="w-12 h-12 text-blue-600 mx-auto mb-4 animate-spin" />
              <h1 className="text-xl font-bold">Confirming payment…</h1>
              <p className="text-slate-500 text-sm mt-2">Please don't close this page. Verifying with Stripe.</p>
            </>
          )}
        </Card>
      </div>
    </div>
  );
}
